// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Collapsible_trigger__3utQL","triggerArrow":"Collapsible_triggerArrow__2EZFC"};